export default function (version) {
  version.has_local_data = true;

  return version;
}
